import React, { useState } from "react";
import styled, { css } from "styled-components";
import { useTranslation } from "react-i18next";
import { IconButton } from "components/common";
const Section = styled.div(
  ({ theme }) => css`
    display: flex;
    gap: ${theme.spacings.xs};
    flex-direction: column;
  `
);
const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
const ExpandableSection = ({ title, children = null }) => {
  const { t } = useTranslation("events");
  const [open, setOpen] = useState(true);
  const onToggle = () => setOpen((cur) => !cur);
  return /* @__PURE__ */ React.createElement(Section, null, /* @__PURE__ */ React.createElement(Header, null, /* @__PURE__ */ React.createElement("h2", null, title), /* @__PURE__ */ React.createElement(
    IconButton,
    {
      onClick: onToggle,
      title: open ? t("alerts_replay.close_section", { title }) : t("alerts_replay.open_section", { title }),
      name: open ? "keyboard_arrow_up" : "keyboard_arrow_down"
    }
  )), open ? children : null);
};
export default ExpandableSection;
